// DS7.4
import React from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import GhostButton from '../Buttons/GhostButton';
import SolidButton from '../Buttons/SolidButton';
import { sanitizeHref } from "@wix/da-url";

import s from './DialogBanner.scss';

export interface Props {
  className?: string;
  message: string | React.ReactNode;
  ctaLabel?: string;
  ctaBiData?: BiEvent;
  dismissLabel?: string;
  dismissBiData?: BiEvent;
  linkLabel?: string;
  linkHref?: string;
  customCtaButton?: React.ReactNode;
  onDismiss?: () => void;
  onClick?: () => void;
}

const DialogBanner: React.FC<Props> = ({
  className,
  message,
  ctaLabel,
  ctaBiData,
  dismissLabel,
  dismissBiData,
  linkLabel,
  linkHref,
  customCtaButton,
  onDismiss,
  onClick,
}) => {
  return (
    <Section className={c(s['root'], className)}>
      <Heading className={s['message']}>{message}</Heading>
      {linkLabel && linkHref && (
        <a className={s['link']} href={sanitizeHref(linkHref)}>
          {linkLabel}
        </a>
      )}
      {(dismissLabel || ctaLabel) && (
        <div className={s['buttons']}>
          {dismissLabel && (
            <GhostButton
              className={s['button']}
              variant="main"
              size="small"
              onClick={onDismiss}
              biData={dismissBiData}
            >
              {dismissLabel}
            </GhostButton>
          )}
          {ctaLabel && (
            <SolidButton
              className={s['button']}
              variant="approval-green"
              size="small"
              onClick={onClick}
              biData={ctaBiData}
            >
              {ctaLabel}
            </SolidButton>
          )}
        </div>
      )}
      {customCtaButton}
    </Section>
  );
};
DialogBanner.displayName = 'DialogBanner';

export default DialogBanner;
